var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSeeDetails(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 14,
    viewBox: "0 0 18 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 0C2.45455 0 0 7 0 7C0 7 2.45455 14 9 14C15.5455 14 18 7 18 7C18 7 15.5455 0 9 0ZM9 1.75C13.3167 1.75 15.5001 5.48371 16.207 6.99658C15.4993 8.49896 13.2995 12.25 9 12.25C4.68327 12.25 2.49988 8.51629 1.79297 7.00342C2.50151 5.50104 4.70045 1.75 9 1.75ZM9 3.5C7.19264 3.5 5.72727 5.06712 5.72727 7C5.72727 8.93287 7.19264 10.5 9 10.5C10.8074 10.5 12.2727 8.93287 12.2727 7C12.2727 5.06712 10.8074 3.5 9 3.5Z",
    fill: "#A1AAB2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeeDetails);
export default __webpack_public_path__ + "static/media/see-details.d57cb570.svg";
export { ForwardRef as ReactComponent };